<template>
  <admin-layout :title="$t('create_x', { x: $t('Role') })">
    <tec-form-section @submitted="submit">
      <template #title>{{ $t('create_x', { x: $t('Role') }) }} </template>
      <template #description> {{ $t('Please fill the form below to add new record.') }} </template>

      <template #form>
        <div class="col-span-full lg:col-span-4">
          <text-input
            v-model="form.name"
            :error="$page.props.errors.name ? $page.props.errors.name.replace('{attribute}', 'name') : null"
            :label="$t('Name')"
          />
        </div>
      </template>

      <template #actions>
        <tec-action-message :on="form.recentlySuccessful" class="mr-3">{{ $t('Saved.') }}</tec-action-message>
        <loading-button type="submit" :loading="form.processing" :disabled="form.processing">{{ $t('Save') }}</loading-button>
      </template>
    </tec-form-section>
  </admin-layout>
</template>

<script>
import TextInput from '@/Shared/TextInput';
import AdminLayout from '@/Layouts/AdminLayout';
import LoadingButton from '@/Shared/LoadingButton';
import TecFormSection from '@/Jetstream/FormSection';
import TecActionMessage from '@/Jetstream/ActionMessage';
import TecSecondaryButton from '@/Jetstream/SecondaryButton';

export default {
  components: {
    TextInput,
    AdminLayout,
    LoadingButton,
    TecFormSection,
    TecActionMessage,
    TecSecondaryButton,
  },

  data() {
    return {
      form: this.$inertia.form({ _method: 'POST', name: null }),
    };
  },

  methods: {
    submit() {
      this.form.post(route('roles.store'), { preserveScroll: true });
    },
  },
};
</script>
